var History = window.History;

(function(root, document, $) {
    'use strict';

    var app = {};

    // begin app
    app = {
        modules: {},
        init: function() {
            // globals
            this.win = $(root);
            this.doc = $(document);
            this.body = $('body');
            this.is_touch = ('ontouchstart' in document.documentElement);

            // init modules
            for (var t in this.modules) this.modules[t].init();
        },
    },

        /**
         * Header
         * -----------------------------
         */
        app.modules.header = {
            $el: null,
            visible: !0,
            hover: !1,
            y: 0,
            buffer: 90,
            timeout: null,
            init: function() {
                var t = this;

                // init sub modules
                if (app.win.width() > 767) {

                    // mouse actions fixed header
                    t.$el = $('#masthead'),
                        t.$el.on('mouseenter', function() {
                            t.hover = !0;
                        }),
                        t.$el.on('mouseleave', function() {
                            t.hover = !1,
                                t.timeout = setTimeout(function() {
                                    t.on_close();
                                }, 1000);
                        });
                    app.win.on('scroll', function() {
                        t.on_scroll();
                    });

                } else {

                    // Clone nav
                    var login_nav    = $('li.login-nav').clone(),
                        downloads_li = $('#menu-downloads > li').clone(),
                        login_cloned = (downloads_li.length > 0 ? downloads_li : login_nav),
                        quick_nav    = $('#quick-nav > ul > li').clone();

                    $('.flexnav').append(login_cloned).append(quick_nav);
                }

                t.lang_switcher();
                t.search_toggle.init();

            },
            on_scroll: function() {
                var t = app.win.scrollTop(),
                    n = t - this.y,
                    i = t >= this.y ? 'down' : 'up';
                if (this.y = t, clearTimeout(this.timeout), 'down' == i) {
                    if (2 > n) {
                        return;
                    }
                    this.on_close();
                } else {
                    if (t > this.buffer && n > -20) {
                        return;
                    }
                    this.on_show();
                }
            },
            on_close: function() {
                var t = app.win.scrollTop();
                this.visible && (this.hover || t > this.buffer && (this.$el.addClass('hide-offscreen'), this.visible = !1));

                if (!this.visible && t > this.buffer) {
                    this.search_toggle.on_close();
                }
            },
            on_show: function() {
                var e = this;
                this.visible || (this.$el.removeClass('hide-offscreen'), this.visible = !0, this.timout = setTimeout(function() {
                    e.on_close();
                }, 4000));
            },

            // lang switcher
            lang_switcher: function() {
                $('.language-switcher select').on('change', function() {
                    var value = $(this).val();
                    window.location.href = value;
                });
            },

            // search toggle
            search_toggle: {
                $toggle: null,
                $target: null,
                init: function() {
                    var t = this;

                    t.$toggle = $('.site-search a'),
                        t.$target = $('.search-form'),
                        t.$toggle.on('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $(this).parent().toggleClass('current');
                            t.$target.find('input[type="text"]').focus();
                            $('ul.flexnav').removeClass('flexnav-show');
                        }),
                        app.doc.on('keydown', function(event) {
                            if (event.keyCode == 27) {
                                t.on_close();
                            }
                        }),
                        app.doc.on('click', function(event) {
                            if (!(t.$target.is(event.target)) && (t.$target.has(event.target).length === 0)) {
                                t.on_close();
                            }
                        });
                    app.doc.on('touchend', function(event) {
                        if (!(t.$target.is(event.target)) && (t.$target.has(event.target).length === 0)) {
                            t.on_close();
                        }
                    });
                },
                on_close: function() {
                    var t = this;
                    t.$toggle.parent().removeClass('current');
                },
            },
        },


        /**
         * Slideshow
         */
        app.modules.slideshow = {
            init: function() {
                $('.slide-texts-wrapper').each(function() {
                    var $el = $(this);
                    var $slides = $el.find('.slide-text');
                    $el.height($($slides[0]).outerHeight());

                    if ($slides.length > 1) {
                        var current = 0;
                        setInterval(function() {
                            $slides.removeClass('slide-text--active');
                            current = (current != $slides.length - 1) ? current + 1 : 0;
                            $el.height($($slides[current]).outerHeight());
                            $($slides[current]).addClass('slide-text--active');
                        }, 3000);
                    }
                });
            },
        },

        /**
         * Slick
         * -----------------------------
         */
        app.modules.slick = {
            init: function() {
                if ($('.slick-slider').length == 0) {
                    return;
                }

                var settings = {
                    dots: true,
                    swipe: (app.is_touch ? true : false),
                    fade: false,
                    arrows: false,
                    accessibility: true,
                    autoplay: true,
                };

                if ($('.slider-main').length) {

                    settings.speed = $('.slider-main')[0].hasAttribute('data-speed') ? parseInt($('.slider-main')
                        .data('speed')) : 4000;
                    settings.fade = $('.slider-main')[0].hasAttribute('data-fade') ? ($('.slider-main')
                        .data('fade') == true) : true;
                    settings.dots = $('.slider-main')[0].hasAttribute('data-dots') ? ($('.slider-main')
                        .data('dots') == true) : true;
                    if ($('.slider-main')[0].hasAttribute('data-pause-on-hover')) {
                        settings.pauseOnHover = $('.slider-main').data('pauseOnHover') == true;
                    }

                    //settings.autoplay = true;
                    settings.autoplaySpeed = $('.slider-main')[0].hasAttribute('data-autoplay-speed')
                                             ? parseInt($('.slider-main').data('autoplaySpeed')) : 7000;
                    // settings.onBeforeChange = function (slide, index) {
                    // 	$(slide.$slides.get(index)).removeClass('slide-anim');
                    // };
                    // settings.onAfterChange = function (slide, index) {
                    // 	$(slide.$slides.get(index)).addClass('slide-anim');
                    // };
                }
                if ($('.slider-product').length) {
                    settings.autoplaySpeed = 5000;
                }

                $('.slick-slider').slick(settings);
            },
        },

        /**
         * Loader
         * -----------------------------
         */
        app.modules.loader = {
            init: function() {
                this.load(false);
            },
            load: function(start) {
                var opts    = {
                        lines: 9,
                        length: 9,
                        width: 4,
                        radius: 5,
                        color: '#fff',
                        className: 'spinner',
                        zIndex: 2e9,
                    },
                    target  = $('#loader'),
                    spinner = new Spinner(opts);

                if (!start) {
                    target.html('').hide();
                    spinner.stop();
                    return;
                }
                spinner.spin();
                target.html(spinner.el).show();
            },
        },

        /**
         * Flexnav
         * -----------------------------
         */
        app.modules.flexnav = {
            init: function() {
                var $el = $('.flexnav');
                $el.attr('data-breakpoint', '767');
                $el.flexNav();
                $el.find('li').each(function() {
                    var t = $(this);
                    if (t.is('[class*="current"]')) {
                        t.find('> .touch-button').addClass('active');
                        t.find('> ul').addClass('flexnav-show').show();
                    }
                });
                $('.touch-button').on('click', function(e) {
                    $('.site-search').removeClass('current');
                });
            },
        },

        /**
         * Forms
         * -----------------------------
         */
        app.modules.gravity_forms =
            {
                init: function() {
                    if ($('.gform_wrapper').length == 0) {
                        return;
                    }

                    $('#gravity-forms').addClass('ready');

                    this.render();
                    this.click();
                    this.placeholders();
                },
                placeholders: function() {
                    var valid_fields_arr = ['text', 'email', 'password', 'textarea', 'select-one'],
                        form             = $('.gform_wrapper form :input');

                    if (form.length > 0) {
                        $.each(form, function(i, field) {
                            if (in_array(valid_fields_arr, field.type)) {
                                var label = $(this).parent().parent().find('.gfield_label');
                                label.hide();
                                if (field.type != 'select-one') {
                                    $(this).attr('placeholder', label.text());
                                }
                            }
                        });
                        $('.gform_fields li').addClass('col-xs-6');
                    }
                },
                click: function() {
                    var t = this;
                    $('.gform_button').on('click', function() {
                        $(this).addClass('loading');
                        t.loader($(this), '#fff');
                    });
                },
                render: function() {
                    var t = this;
                    app.doc.bind('gform_post_render', function() {
                        t.placeholders();
                        t.click();
                    });
                },
                loader: function(el, color) {
                    var opts    = {
                            lines: 9,
                            length: 3,
                            width: 4,
                            radius: 4,
                            color: color,
                            className: 'spinner',
                            zIndex: 2e9,
                        },
                        spinner = new Spinner(opts).spin();
                    el.append(spinner.el);
                },
            },

        /**
         * Modal
         * -----------------------------
         */
        app.modules.modal = {
            init: function() {
                if ($('a.video-popup').length > 0) {
                    this.video();
                }
                if ($('a.dealer-popup').length > 0 && typeof distributors !== 'undefined') {
                    this.dealer();
                }

                this.product();
                this.popup();
            },
            product: function() {
                var toggle      = $('li.product-modal a, a.product-modal'),
                    response_el = $('#product-modal');

                toggle.on('click', function(e) {

                    // Only make the request the first time the link has been clicked
                    if (response_el.find('.product-modal-content').length > 0) {
                        response_el.modal();
                        return;
                    }

                    e.preventDefault();

                    app.modules.loader.load(true);

                    var jqxhr = $.ajax(
                        {
                            type: 'GET',
                            url: ajax_url,
                            data: {
                                action: 'hallde_products_load',
                                lang: theme.current_language,
                            },
                        })
                        .done(function(response) {
                            if (response == null) {
                                return;
                            }
                            response_el.find('.modal-body').html(response);
                            response_el.modal();
                        })
                        .fail(function(e) {
                        })
                        .always(function() {
                            app.modules.loader.load(false);
                        });
                });

            },
            video: function() {
                var t = this;
                $('a.video-popup').on('click', function() {
                    var t     = $(this),
                        modal = t.data('target'),
                        video = t.data('video'),
                        title = t.attr('title');

                    $(modal).on('shown.bs.modal', function(e) {
                        $(modal + ' iframe')
                            .attr('src', video + '?autoplay=1&amp;rel=0&amp;fs=1&amp;showinfo=1&amp;controls=1&amp;autohide=1&amp;theme=light&amp;color=white&amp;modestbranding=0');
                        $(modal + ' h3').html(title);
                    });
                });

                $('#video-modal').on('hide.bs.modal', function(e) {
                    $(this).find('iframe').attr('src', '');
                });
            },
            dealer: function() {
                var t = this;

                $('a.dealer-popup').on('click', function() {

                    var dealer     = $(this),
                        modal      = dealer.data('target'),
                        code       = dealer.data('code'),
                        title      = dealer.attr('title'),
                        email      = dealer.data('email'),
                        country_id = dealer.data('id'),
                        data       = '',
                        has_data   = false;

                    // distributors
                    $.each(distributors.data, function(i, item) {

                        if (item.country == country_id) {
                            data += '<div class="col-sm-12">';
                            data += '<h5>' + item.title + '</h5>';
                            data += item.content;
                            data += '</div>';
                            has_data = true;
                        }
                    });

                    if (has_data) {
                        $('.distributor-data').html(data);
                        $(modal + ' iframe').hide();
                        $(modal).find('iframe').attr('src', '');
                    } else {
                        $('.distributor-data').html('');
                        $(modal + ' iframe').show();
                        $(modal + ' iframe').attr('src', $('.component-distributor-list')
                            .data('iframe') + '?country=' + title + '&email=' + email + '&version=1.1');
                        has_data = false;
                    }

                    $(modal).on('shown.bs.modal', function(e) {
                        $(modal + ' .flag').attr('class', 'flag flag-large').addClass('flag-' + code);
                        $(modal + ' h3').html(title);
                    });

                    $(modal).on('hide.bs.modal', function(e) {
                        $(modal).find('iframe').attr('src', '');
                    });

                });
            },
            popup: function() {
                var t       = this,
                    modalEl = $('#popup-modal');

                modalEl.modal('show');
            },
        },

        /**
         * Product Comparison
         * -----------------------------
         */
        app.modules.comparison = {
            selected: [],
            init: function() {
                var t = this;

                t.select();
                t.click();

                if ($('.compare-portions').length > 0) {
                    t.filter();
                }

                if (GET('compare')) {
                    t.selected = GET('compare').split(',');
                    if (t.selected.length >= 2 && t.selected.length < 4) {
                        t.load_compare();
                    }
                }

                if (History.enabled) {
                    History.Adapter.bind(window, 'statechange', function() {
                        var State = History.getState();
                        t.show_view(State.data.view);
                    });
                }

            },
            select: function() {
                var t = this;

                $('.checkbox').on('change', function() {

                    var cb    = $(this),
                        val   = cb.val(),
                        index = t.selected.indexOf(val);

                    if (index > -1) {
                        t.selected.splice(index, 1);
                    } else {
                        t.selected.push(val);
                    }

                    cb.parents('.product-item').toggleClass('checked');
                    t.set();
                });
            },
            set: function() {
                var t  = this,
                    cb = $('input:checkbox:not(:checked)');

                if (t.selected.length >= 3) {
                    cb.parents('.product-item').addClass('inactive');
                    cb.attr('disabled', 'disabled');
                } else {
                    cb.parents('.product-item').removeClass('inactive');
                    cb.removeAttr('disabled');
                }
            },
            click: function() {
                var t = this;

                $('.compare-action').on('click', function(e) {
                    e.preventDefault();
                    if (t.selected.length >= 2 && t.selected.length < 4) {
                        t.load_compare();
                    } else if (t.selected.length > 3) {
                        $('#comparison-modal').modal('show');
                    } else {
                        $('#comparison-modal').modal('show');
                    }
                });

                $('.btn-print').on('click', function(e) {
                    e.preventDefault();
                    window.print();
                });
            },
            load_compare: function() {
                var t = this;
                app.modules.loader.load(true);


                /*
                            $.ajax( ajax_url, {
                                data: {
                                    action: 'test_func',
                                    product_ids: t.selected.join( ',' ),
                                    lang: theme.current_language,
                                },
                                success: function( response ) {
                                    if ( response == null ) return;
                                    t.response = response;
                                    t.show_view( 'compare' );
                                },
                                always: function() {
                                    app.modules.loader.load( false );
                                }
                            });
                */

                var params = {
                        action: 'hallde_product_comparison',
                        product_ids: t.selected.join(','),
                        lang: theme.current_language,
                    },
                    jqxhr  = $.ajax(
                        {
                            type: 'GET',
                            url: ajax_url,
                            data: params,
                        })
                        .done(function(response) {
                            if (response == null) {
                                return;
                            }
                            t.response = response;
                            t.show_view('compare');
                        })
                        .fail(function(e) {
                        })
                        .always(function() {
                            app.modules.loader.load(false);
                        });
            },
            show_view: function(view) {
                var t = this;

                if (view === 'compare') {
                    $('.product-comparison').html(t.response).fadeIn('fast', function() {
                        if (History.enabled) {
                            History.pushState({ view: 'compare' }, document.title, '?compare=' + t.selected);
                        }
                    });
                    $('.compare-ready-header').addClass('ready');
                    $('.product-list-items, #compare-footer, .cpt-content').hide();
                    $('.compare-header').addClass('inactive');
                } else {
                    $('.product-comparison').hide().empty();
                    $('.compare-ready-header').removeClass('ready');
                    $('.product-list-items, #compare-footer, .cpt-content').show();
                    $('.compare-header').removeClass('inactive');
                    if (History.enabled) {
                        History.pushState({ view: 'list' }, document.title, '');
                    }
                }
            },
            filter: function() {
                var t = this;

                $('.compare-portions select').on('change', function() {
                    var option = $(this),
                        val    = option.val();

                    if (val === '') {
                        return;
                    }
                    t.load_filter(val);
                });
            },
            load_filter: function(val) {
                var t = this;
                app.modules.loader.load(true);


                var params = {
                        action: 'hallde_product_filter',
                        portions: val,
                        lang: theme.current_language,
                    },
                    jqxhr  = $.ajax(
                        {
                            type: 'GET',
                            url: ajax_url,
                            data: params,
                        })
                        .done(function(response) {
                            if (response == null) {
                                return;
                            }
                            t.selected = [];
                            $('.product-list-items').html(response).fadeIn('fast', function() {
                                t.select();
                                t.click();
                            });
                        })
                        .fail(function(e) { /* console.log( 'Ajax load failed. Reason: ' + e ); */
                        })
                        .always(function() {
                            app.modules.loader.load(false);
                        });
            },
        },

        /**
         * Cutting Results
         * -----------------------------
         */
        app.modules.cutting_results = {
            init: function() {
                if ($('.component-cutting-results').length == 0) {
                    return;
                }

                this.filter();

                if (GET('filter')) {
                    this.load_filter(GET('filter'));
                } else {
                    this.load_filter('all');
                }

            },
            filter: function() {
                var t = this;

                $('.cutting-results-filter select').on('change', function() {
                    var option = $(this),
                        val    = option.val();

                    if (val === '') {
                        return;
                    }

                    t.load_filter(val);

                });
            },
            load_filter: function(val) {
                app.modules.loader.load(true);

                var params = {
                        action: 'hallde_ingredient_filter',
                        ingredient: val,
                        lang: theme.current_language,
                    },
                    jqxhr  = $.ajax(
                        {
                            type: 'GET',
                            url: ajax_url,
                            data: params,
                        })
                        .done(function(response) {
                            if (response == null) {
                                return;
                            }
                            $('#ingredient-result').hide().html(response).fadeIn();
                            app.modules.modal.video();

                            //if ( History.enabled ) History.pushState( '', '', '?filter=' + val );
                        })
                        .fail(function(e) { /* console.log( 'Ajax load failed. Reason: ' + e ); */
                        })
                        .always(function() {
                            app.modules.loader.load(false);
                        });
            },
        },

        /**
         * Accordion
         * -----------------------------
         */
        app.modules.accordion = {
            init: function() {
                if ($('.accordion').length == 0) {
                    return;
                }

                var accordion = $('.accordion');
                accordion.find('.accordion-holder').css({
                    display: 'none',
                    overflow: 'hidden',
                });
                accordion.on('click', 'h3.accordion-headline, h2.accordion-headline', function() {

                    var t = $(this);
                    var target = t.next('.accordion-holder');
                    var target_content = target.find('.accordion-content');
                    t.toggleClass('active');

                    if (!target_content.hasClass('active')) {
                        target.css('display', 'block');
                        target_content.css('margin-top', -target_content.height());
                        target_content.velocity({ marginTop: 0 }, { duration: 350 });
                        target_content.addClass('active');
                    } else {
                        target_content.velocity({ marginTop: -target_content.height() }, { duration: 350 });
                        target_content.removeClass('active');
                    }

                    return false;

                });
            },
        },

        app.modules.flag_accordion = {
            toggle: $('.flag_headline'),
            init: function() {
                var t = this;

                if (t.toggle.length == 0) {
                    return;
                }

                t.toggle.addClass('accordion');
                t.toggle.find('h2').css('display', 'block').addClass('accordion-headline')
                    .append('<i class="icon-arrow-down2"></i>');

                // Loop each flag headline and wrap in div
                t.toggle.each(function(i, item) {
                    $(this).nextUntil('.flag_headline')
                        .wrapAll('<div class="accordion-holder"><div class="accordion-content">');
                });

                t.accordion();
            },
            accordion: function() {
                var t = this;

                t.toggle.next('.accordion-holder').css({
                    display: 'none',
                    overflow: 'hidden',
                });
                t.toggle.on('click', function() {

                    var t = $(this);
                    var target = t.next('.accordion-holder');
                    var target_content = target.find('.accordion-content');
                    t.find('h2').toggleClass('active');

                    if (!target_content.hasClass('active')) {
                        target.css('display', 'block');
                        target_content.css('margin-top', -target_content.height());
                        target_content.velocity({ marginTop: 30 }, { duration: 350 });
                        target_content.addClass('active');
                    } else {
                        target_content.velocity({ marginTop: -target_content.height() }, { duration: 350 });
                        target_content.removeClass('active');
                    }

                    return false;

                });
            },
        },

        /**
         * Tabs
         * -----------------------------
         */
        app.modules.tab = {
            init: function() {
                if (('.tab-content').length == 0) {
                    return;
                }

                var t = this;

                if (GET('view') !== '') {
                    t.view = GET('view');
                    t.show();
                } else {
                    t.view = 'range';
                }

                t.click();

                /*
                            if ( History.enabled ) {
                                History.Adapter.bind ( window, 'statechange', function() {
                                    var State = History.getState();

                                    //if ( typeof State.data.tab_view == 'undefined' ) return;

                                    //console.log( 1 );

                                    if ( GET( 'view' ) !== '' ) {
                                        t.view = GET( 'view' )
                                    } else {
                                        t.view = ( typeof State.data.tab_view == 'undefined' ? 'range' : State.data.tab_view );
                                    }

                                    t.show();
                                });
                            }
                */

            },
            click: function() {
                var t = this;

                $('#tabs a').on('click', function(e) {

                    e.preventDefault();

                    var tab  = $(this),
                        view = tab.data('tab');

                    t.view = view;

                    //console.log( view );

                    if (History.enabled) {
                        History.pushState({ tab_view: view }, document.title, '?view=' + t.view);
                    }

                    t.show();
                });
            },
            show: function() {
                var t           = this,
                    tab_link    = $('#tabs a'),
                    tab_content = $('.tab-content');

                tab_link.parent().removeClass('active');
                tab_link
                    .filter('[data-tab="' + t.view + '"]')
                    .parent()
                    .addClass('active');
                tab_content
                    .removeClass('tab-active')
                    .filter('[data-tab="' + t.view + '"]')
                    .addClass('tab-active');
            },
        },

        /**
         * Cookiebar
         * -----------------------------
         */
        app.modules.cookieBar = {
            init: function() {

                if (0 < theme.optionPageCookiesContent.length && 0 < theme.optionPageCookiesButton.length) {
                    $.cookieBar({
                        message: theme.optionPageCookiesContent,
                        acceptText: theme.optionPageCookiesButton,
                        fixed: true,
                        bottom: true,
                    });
                }
            },
        };


    // publish
    root.app = app;

    // init
    $(root).ready(function() {
        app.init();
    });

})(window, document, jQuery);

/**
 * in array helper
 *
 */
function in_array(arr, obj) {
    return (arr.indexOf(obj) != -1);
}

/**
 * indexOf prototype function
 *
 */
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(obj, start) {
        for (var i = (start || 0), j = this.length; i < j; i++) {
            if (this[i] === obj) {
                return i;
            }
        }
        return -1;
    }
}

/**
 * GET
 *
 */
function GET(key) {
    var s = History.getState(),
        t = unescape(s.url.replace(new RegExp("^(?:.*[&\\?]" + escape(key)
            .replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));

    if (t == '') {
        t = unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape(key)
            .replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    return t;
}
